import React from "react";
import "./JoinClanInfo.css";
import { useNavigate } from "react-router-dom";

const JoinClanInfo = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/join-form");
    };

    return (
        <div className="join-clan-container">
            <div className="join-clan-info">
                <h2 className="join-title">rekruitmen Team TFH</h2>
                <p className="join-description">
                    Bosan main sendiri terus? Tenang! Kami dari keluarga TFH sedang membuka rekruitmen untuk kamu yang ingin menjadi bagian dari keluarga kami...
                </p>
                <button className="join-button" onClick={handleClick}>
                    Gabung Sekarang!
                </button>
            </div>
        </div>
    );
};

export default JoinClanInfo;